import React from "react";
import { getErrorMessage, getFieldErrors } from "./accountErrors";
import { formatINR } from "./accountUser";
import FormDialog from "../../Components/Accounts/FormDialog";
import ReasonDialog from "../../Components/Accounts/ReasonDialog";
import CreditPanel from "../../Components/Accounts/CreditPanel";

export { FormDialog, ReasonDialog, CreditPanel };

const STATUS = {
  POSTED: ["Posted", "ok"],
  CANCELLED: ["Cancelled", "bad"],
  CREDIT_HOLD: ["Credit hold", "warn"],
  APPROVED: ["Approved", "ok"],
  LOADING: ["Loading", "info"],
  INVOICED: ["Invoiced", "muted"],
  OPEN: ["Open", "info"],
  PARTIAL: ["Part paid", "info"],
  PAID: ["Paid", "ok"],
  Unpaid: ["Unpaid", "warn"],
};

const INVOICE_STATUS = {
  OPEN: ["Unpaid", "warn"],
  PARTIAL: ["Part paid", "info"],
  PAID: ["Paid", "ok"],
  CANCELLED: ["Cancelled", "bad"],
};

export function StatusChip({ status, label, kind }) {
  const pair = (kind === "invoice" ? INVOICE_STATUS : STATUS)[status];
  const text = label || (pair ? pair[0] : status || "");
  const tone = pair ? pair[1] : "";
  return <span className={`accounts-chip ${tone}`}>{text}</span>;
}

export function ApiAlert({ error }) {
  const message = getErrorMessage(error);
  const fields = getFieldErrors(error);
  const list = Object.values(fields);
  if (!message && list.length === 0) return null;
  return (
    <div className="accounts-error" role="alert">
      {message && <div>{message === "Validation failed" && list.length ? "Please check:" : message}</div>}
      {list.length > 0 && (
        <ul>{list.map((item) => <li key={item}>{item}</li>)}</ul>
      )}
    </div>
  );
}

export function FieldHint({ error, help }) {
  return <span className={`accounts-hint ${error ? "tally-error" : ""}`}>{error || help || " "}</span>;
}

export function Notice({ tone, children }) {
  if (!children) return null;
  return <div className={`accounts-note ${tone || "ok"}`}>{children}</div>;
}

export function ItemsTable({ items }) {
  const rows = items || [];
  const total = rows.reduce((sum, item) => sum + Number(item.amount || 0), 0);
  return (
    <div className="accounts-table-wrap">
      <table className="accounts-table">
        <thead><tr><th>Product</th><th className="num">Quantity</th><th className="num">Rate</th><th className="num">Amount</th></tr></thead>
        <tbody>
          {rows.map((item, index) => (
            <tr key={`${item.description}-${index}`}>
              <td>{item.description}{item.gstPercent ? <span className="accounts-hint"> · {item.igst ? "IGST" : "GST"} {item.gstPercent}%{item.hsn ? ` · HSN ${item.hsn}` : ""}</span> : null}</td>
              <td className="num">{item.quantity} {item.unit || "BAG"}</td>
              <td className="num">{formatINR(item.rate)}</td>
              <td className="num">{formatINR(item.amount)}</td>
            </tr>
          ))}
          {rows.length === 0 && <tr><td colSpan={4}>No items</td></tr>}
        </tbody>
        {rows.length > 0 && <tfoot><tr><td colSpan={3}>Total</td><td className="num">{formatINR(total)}</td></tr></tfoot>}
      </table>
    </div>
  );
}

export function Pager({ page, limit, total, onPage, onLimit, sizes = [10, 20, 50] }) {
  const pages = Math.max(1, Math.ceil((total || 0) / limit) || 1);
  return (
    <div className="accounts-form-actions start">
      <button type="button" className="btn btn-outline-secondary" disabled={page <= 1} onClick={() => onPage(page - 1)}>Previous</button>
      <span className="accounts-hint">Page {page} of {pages}</span>
      <button type="button" className="btn btn-outline-secondary" disabled={page >= pages} onClick={() => onPage(page + 1)}>Next</button>
      <select className="form-select accounts-pager-size" value={limit} onChange={(event) => onLimit(Number(event.target.value))}>
        {sizes.map((size) => <option key={size} value={size}>{size}</option>)}
      </select>
    </div>
  );
}

export const PRODUCTS = ["OPC 53 Grade Cement", "OPC 43 Grade Cement", "PPC Cement", "PSC Cement"];
